import {makeActionCreator, makeActionType, getActionType} from '../util/redux';
import Request from '../util/fetch';

const URL_HEADER1 = '';
export const PAGESIZE = 10;
export const PlanType = 'plan';

makeActionType(PlanType, ['bankcardRequest', 'earningListSuccess', 'withdrawListSuccess', 'earnOverviewSuccess', 'withdrawOverviewSuccess', 'requestFail']);
export const earningListSuccess = makeActionCreator(getActionType(PlanType, 'earningListSuccess'));
export const withdrawListSuccess = makeActionCreator(getActionType(PlanType, 'withdrawListSuccess'));
export const earnOverviewSuccess = makeActionCreator(getActionType(PlanType, 'earnOverviewSuccess'));
export const withdrawOverviewSuccess = makeActionCreator(getActionType(PlanType, 'withdrawOverviewSuccess'));
export const requestFail = makeActionCreator(getActionType(PlanType, 'requestFail'));

/**
 * 每月收益列表
 * @param {*} data
 */
export const monthEarningList = (param) => (dispatch) => {
  let page = param.page;
  let subAccount = !!param.subAccount;
  let data = {
    limit: PAGESIZE,
    offset: Math.max((param.page - 1) * PAGESIZE, 0)
  }
  let url = '/api/cloudvideo/activity/monthearnings/get';

  if (subAccount) {
    url = '/api/cloudvideo/activity/moneyplan/children/monthearnings/get';
    data.childUserId = param.subAccount;
  }

  return Request.fetch({url, data}).then((result) => {
    let resdata = {};
    resdata.list = result.data;
    resdata.total = result.total;
    resdata.page = page;
    return dispatch(earningListSuccess(resdata));

  }).catch((error) => {
    let rerr = Request.resolveError(error);
    dispatch(requestFail({msg1: rerr}));
  })

}


/**
 * 提现记录列表
 * @param {*} data
 */
export const withdrawRecordsList = (data) => (dispatch) => {
  let page = data.page;
  return Request.fetch({
    url: 'api/cloudvideo/activity/moneyplan/withdraw/records/list',
    data: {
      limit: PAGESIZE,
      offset: Math.max((data.page - 1) * PAGESIZE, 0)
    }
  }).then((result) => {
    let resdata = {};
    resdata.list = result.data;
    resdata.total = result.total;
    resdata.page = page;
    return dispatch(withdrawListSuccess(resdata));
  }).catch((error) => {
    let rerr = Request.resolveError(error);
    dispatch(requestFail({msg2: rerr}));
  })

}


/**
 * 收益概览
 * @param {*} data
 */
export const earnsOverview = (data) => (dispatch) => {
  return Request.fetch({
    url: '/api/cloudvideo/activity/moneyplan/earns'
  }).then((result) => {
    let resdata = {};
    resdata.list = result.data.videoEarningsVoList;
    resdata.date = result.date;
    resdata.companyUser = result.data.companyUser;
    resdata.videoIncome = result.data.videoIncome;
    resdata.coefficient = result.data.coefficient;
    return dispatch(earnOverviewSuccess(resdata));

  }).catch((error) => {
    let rerr = Request.resolveError(error);
    dispatch(requestFail({msg3: rerr}));
  })

}

/**
 * 可提现收益概览
 * @param {*} data
 */
export const withdrawOverview = (data) => (dispatch) => {
  dispatch({
    type: getActionType(PlanType, 'bankcardRequest'),
    payload: {bankInfoRequesting: true}
  });
  return Request.fetch({
    hostname1: URL_HEADER1,
    url: 'api/cloudvideo/activity/moneyplan/withdraw/Info/get'
  }).then((result) => {
    let resdata = {};
    resdata.list = result.data;
    dispatch({
      type: getActionType(PlanType, 'bankcardRequest'),
      payload: {bankInfoRequesting: false}
    });
    dispatch(withdrawOverviewSuccess(resdata));
    return result.data;

  }).catch((error) => {
    let rerr = Request.resolveError(error);
    dispatch(requestFail({msg4: rerr}));
  })

}

/**
 * 用户发起提现
 * @param {*} data
 */
export const withdrawRequest = (data) => (dispatch) => {
  // TODO: 发起提前请求
  return Request.fetch({
    hostname1: URL_HEADER1,
    url: 'api/cloudvideo/activity/moneyplan/money/withdraw',
    data
  }).then((result) => {
    return result;

  }).catch((error) => {
    return Request.resolveError(error);
  })

}



// WEBPACK FOOTER //
// ./client/action/plan.js